
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Menu.css';
import red from '../../img/red.png';

function Menu({ onTitleChange }) {
  // const [activeLink, setActiveLink] = useState(null);
   const [title, setTitle] = useState(null);
  // const [titleStyle, setTitleStyle] = useState({});
   const [isActive, setIsActive] = useState(false);

   const handleLinkClick = (title) => {
  //   setActiveLink(title);
  //   setTitle(title);
     setIsActive(true);
  };
  const activeLinkStyle = ({isActive})=>{
    return{
      color: isActive ? "black" : "",  
      pointerEvents: isActive ? "":"none"
      
      }
    
    }
  
  return (
    <div className='menu-container'>
      <nav className='menu-company'>
       
      <NavLink 
        to='/customers'
        style={activeLinkStyle}
        
    >
    
            <p>Typ klienta</p>
    </NavLink>
        <NavLink
          to='/companySearch'
          style={activeLinkStyle}
         
        >
          <p>Dane Firmy</p>
        </NavLink>
        <NavLink
          to='/companyRegistration'
          style={activeLinkStyle}
        >
          <p>Zgłoszenie</p>
        </NavLink>
        <NavLink
          to='/companyReceiptGoods'
          style={activeLinkStyle}
        >
          <p>Miejsce odbioru towaru</p>
        </NavLink>
        <NavLink
          to='/companySummary'
          style={activeLinkStyle}
        >
          <p>Podsumowanie</p>
        </NavLink>
      </nav>

    </div>
  );
}

export default Menu;